<template>
  <div id="g-recaptcha"></div>
</template>

<script>
export default {
  methods: {
    loadReCaptcha: function() {
      var self = this;
      // Wait for Recaptcha library to load before trying to render it.
      setTimeout(function() {
        if (!window.grecaptcha || typeof window.grecaptcha.render !== 'function') {
          self.loadReCaptcha(); // loop if it takes over 250 milliseconds to load
        } else {
          self.initReCaptcha();
        }
      }, 250);
    },
    initReCaptcha() {
      window.grecaptcha.render('g-recaptcha', {
        sitekey: '6LeyLrYrAAAAAKTXoUOYWv70Cj0oXMBN53KegLtm', // Key lives here https://www.google.com/recaptcha/admin/site/733359794/settings
        // Old Key not sure where it lives '6LeXmZQbAAAAAJ0WrEBfQG49MfaB4TbQiMnLFnMy',
        callback: response => {
          this.$emit('captchaUpdate', response);
        },
        'expired-callback': response => {
          this.$emit('captchaUpdate', response);
        },
      });
    },
    resetCaptcha() {
      window.grecaptcha.reset();
      this.$emit('captchaUpdate');
    },
  },
  mounted() {
    this.loadReCaptcha();
  },
};
</script>
